module.exports = require("@seddi/three/addons/postprocessing/EffectComposer.js");